import RequirementsStep from '../components/tabs-content/pages/requirements'
import UploadFilesStep from '../components/tabs-content/pages/upload-files'
// import CheckingDuplicatesStep from '../components/tabs-content/pages/checking-duplicates'
import Processing from '../components/tabs-content/pages/processing-suppliers';
import ProcessingProducts from '../components/tabs-content/pages/processing-products';
import ImportDocuments from '../components/tabs-content/pages/import-documents';
import Confirmation from '../components/tabs-content/pages/confirmation';
import Finalize from '../components/tabs-content/pages/finalize';

const steps = [
    {
        title: 'Requirements',
        stepUniqueKey: 'requirements',
        component: (props) => <RequirementsStep {...props} />
    },
    {
        title: 'Upload Files',
        stepUniqueKey: 'upload_files',
        component: (props) => <UploadFilesStep {...props} />
    },
    {
        title: 'Confirm Import',
        stepUniqueKey: 'confirmation',
        component: (props) => <Confirmation {...props} />
    },
    {
        title: 'Importing Suppliers',
        stepUniqueKey: 'processing',
        component: (props) => <Processing {...props} />
    },
    {
        title: 'Importing Products',
        stepUniqueKey: 'processing_products',
        component: (props) => <ProcessingProducts {...props} />
    },
    {
        title: 'Documents',
        stepUniqueKey: 'import_documents',
        component: (props) => <ImportDocuments {...props} />
    },
    {
        title: 'Import Complete',
        stepUniqueKey: 'processing_done',
        component: (props) => <Finalize {...props} />
    },
    // {
    //     title: 'Checking Duplicates',
    //     stepUniqueKey: 'checking_duplicates',
    //     component: (props) => <CheckingDuplicatesStep {...props} />
    // }
];

export {
    steps
}